import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./store/index";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import awsconfig from "./aws-exports";
import Amplify from "aws-amplify";
import "react-toastify/dist/ReactToastify.css";
import "./index.scss";

Amplify.configure(awsconfig);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
